import { Fragment, FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import PatientApi from "Service/Patient.api";
import { RedoxAllergyType } from "DataTypes/Services/Patient.type";
import Loader from "Components/Loader";
import NoData from "Components/NoData";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { SideModalProps } from "DataTypes/Modal";
import RedoxFormatter from "Utils/Redox.Formatter";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import UpdateAllergy from "./UpdateAllergy";

export interface DataActionType {
  data: RedoxAllergyType | null;
  action: "ADD" | "EDIT" | "VIEW" | null;
}

const Allergy: FC<SideModalProps> = (props) => {
  const { onClose } = props;
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const [allergyList, setAllergyList] = useState<RedoxAllergyType[]>([]);
  const [loading, setLoading] = useState(true);
  const [dataAction, setDataAction] =
    useState<DataActionType>({ data: null, action: null });

  useEffect(() => {
    getAllergyData();
  }, []);

  const getAllergyData: () => void = async () => {
    const res: any = await PatientApi.RedoxAllergy({ id1: patientInfo.id });
    if (res?.success) {
      setAllergyList(RedoxFormatter.AllergiesList(res?.data?.allergies));
    }
    setLoading(false);
  };

  const handleCloseLayer2: () => void = () => {
    setDataAction({ data: null, action: null })
  };

  const Layer1Header = (
    <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
      <Typography fontWeight="bold">Allergies</Typography>
      <Box display={"flex"}>
        {/* <Box
          sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
          onClick={() => setDataAction({ data: null, action: "ADD" })}
        >
          <ImgPath.PlusIcon titleAccess="Add Allergy" />
        </Box> */}
        <Box
          sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
          onClick={() => {
            handleCloseLayer2();
            onClose();
          }}
        >
          <ImgPath.CloseIcon titleAccess="Close" />
        </Box>
      </Box>
    </Box>
  );

  const Layer1List = (
    allergyList.map((el) => {
      return (
        <Typography key={el.id} variant="body2" sx={{ mb: 1 }}>
          • {el.name}
        </Typography>
      );
    })
  );

  const Layer1 = (
    <Fragment>
      {Layer1Header}
      <Box sx={{ ...sxMain }}>
        {loading ? <Loader /> : allergyList.length ? Layer1List : <NoData />}
      </Box>
    </Fragment>
  );

  return (
    <Fragment>
      <Box width="25%">{Layer1}</Box>
      <Box width="1%"></Box>
      {dataAction.action && (
        <Box width="64%">
          <UpdateAllergy
            dataAction={dataAction}
            onClose={handleCloseLayer2}
            refreshList={getAllergyData}
          />
        </Box>
      )}
    </Fragment>
  );
};
export default Allergy;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "90%",
  overflow: "auto",
  px: 2,
};
